// scroll-spy + 平滑滚动
document.addEventListener('DOMContentLoaded',()=>{
  const nav   = document.querySelector('.pdNav');
  console.log(nav)
  if(!nav) return;          // 没有导航就不执行
  const links = nav.querySelectorAll('a[data-target]');
  const sections = [...links].map(a=>document.getElementById(a.dataset.target)).filter(Boolean);
  console.log(links,sections)
  const observer = new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){
        links.forEach(a=>a.classList.remove('active'));
        const active = nav.querySelector(`[data-target="${entry.target.id}"]`);
        if(active) active.classList.add('active');
      }
    });
  },{rootMargin:'-40% 0px -60% 0px'});

  sections.forEach(sec=>observer.observe(sec));

  nav.addEventListener('click',e=>{
    if(e.target.tagName==='A'){
      e.preventDefault();
      const id = e.target.getAttribute('href');
      document.querySelector(id)?.scrollIntoView({behavior:'smooth',block:'start'});
    }
  });
});